// extracted by mini-css-extract-plugin
export default {"loading_spinner":"Loading_loading_spinner__N8lS3","rotate":"Loading_rotate__i67dU"};